export function closeAllDropdowns() {
    document.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
    document.querySelectorAll('.select-search-dropdown.active').forEach(d => d.classList.remove('active'));
}
